// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.alert[data-v-d0c93148] {\r\n  position: absolute;\r\n  right: 5%;\r\n  top: 5%;\r\n  z-index: 10;\n}\r\n", ""]);
// Exports
module.exports = exports;
